import {useCallback} from 'react';
import {useSelector} from 'react-redux';

import {getLicenseFeatures} from 'src/openapi/admin/apis/GetLicenseFeaturesApi';
import {useAppDispatch} from 'src/store/hooks';

import {selectLicenseFeatures} from './services/dictionary-slice';

export const useLicenseFeatures = () => {
    const apiDispatch = useAppDispatch();
    const licenseFeatures = useSelector(selectLicenseFeatures);

    const loadLicenseFeatures = useCallback(() => {
        if (!licenseFeatures.length) {
            apiDispatch(getLicenseFeatures());
        }
    }, [licenseFeatures.length, apiDispatch]);

    return {licenseFeatures, loadLicenseFeatures};
};
